<template>
    <div class="placeholder">
        <div class="filter-row">
            <span style="font-size: 13px; font-weight: normal">
                Book:
                <v-select
                    :items="bookOptions"
                    dense
                    class="pl-1"
                    hide-details
                    :menu-props="{ offsetY: true }"
                    style="
                        display: inline-block;
                        font-size: 13px;
                        max-width: 150px;
                    "
                    v-model="selectedBook"
                >
                </v-select>
            </span>
        </div>
        <div>
            <v-data-table
                dense
                :headers="tableHeader"
                :items="tableData"
                :header-props="{ sortIcon: null }"
                item-key="id"
                class="elevation-0 flex-grow-1"
                :items-per-page="-1"
                fixed-header
                hide-default-footer
                :loading="loading"
            >
                <template v-slot:item.login="{ item }">
                    <a @click="redirectTo('info', item.login, item.server_id)">
                        {{ item.login }}</a
                    >
                </template>
                <template v-slot:item.pnl="{ item }">
                    {{ numberWithCommas(item.pnl.toFixed(2)) }}
                </template>
                <template v-slot:item.open_pnl="{ item }">
                    {{ numberWithCommas(item.open_pnl.toFixed(2)) }}
                </template>
                <template v-slot:item.close_pnl="{ item }">
                    {{ numberWithCommas(item.close_pnl.toFixed(2)) }}
                </template>
                <template v-slot:item.volume_usd="{ item }">
                    {{
                        numberWithCommas((item.volume_usd / 100000).toFixed(2))
                    }}
                </template>
                <template v-slot:item.action="{ item }">
                    <div style="white-space: nowrap">
                        <span v-if="item.watchlist"
                            ><v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        color="green darken-2"
                                        x-small
                                        @click="
                                            redirectTo(
                                                'view',
                                                item.login,
                                                item.server_id,
                                                item.watchlist
                                            )
                                        "
                                    >
                                        <v-icon> mdi-eye </v-icon>
                                    </v-btn>
                                </template>
                                <span>Detail of login Watchlist</span>
                            </v-tooltip>
                        </span>
                        <span v-else
                            ><v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        color="yellow darken-2"
                                        x-small
                                        @click="
                                            redirectTo(
                                                'add',
                                                item.login,
                                                item.server_id
                                            )
                                        "
                                    >
                                        <v-icon> mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add login to Watchlist</span>
                            </v-tooltip>
                        </span>
                        <span v-if="showAiAnalysisButton" class="ml-1 mr-1"
                            ><v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        color="primary"
                                        x-small
                                        :loading="
                                            aiResult[
                                                selectedBook +
                                                    ':' +
                                                    item.server_id +
                                                    ':' +
                                                    item.login
                                            ] === 'loading'
                                        "
                                        @click="() => getResult(item)"
                                    >
                                        <v-icon>
                                            fa-wand-magic-sparkles
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Click to request AI analysis</span>
                            </v-tooltip>
                        </span>
                        <span
                            v-if="
                                !!aiResult[
                                    selectedBook +
                                        ':' +
                                        item.server_id +
                                        ':' +
                                        item.login
                                ] &&
                                aiResult[
                                    selectedBook +
                                        ':' +
                                        item.server_id +
                                        ':' +
                                        item.login
                                ] !== 'loading'
                            "
                            ><v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        icon
                                        color="orange darken-2"
                                        x-small
                                        @click="
                                            openMessage(
                                                aiResult[
                                                    selectedBook +
                                                        ':' +
                                                        item.server_id +
                                                        ':' +
                                                        item.login
                                                ]
                                            )
                                        "
                                        ><v-icon>
                                            fa-magnifying-glass-chart
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Click to view AI analysis result</span>
                            </v-tooltip>
                        </span>
                    </div>
                </template>
            </v-data-table>

            <WatchlistDisplayModal
                :watchlistModal="watchlistModal"
                :watchlistData="watchlistData"
                :closeModal="
                    () => {
                        watchlistModal = false;
                    }
                "
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { fetchRankingData } from "@services/functional-api";
import { helper } from "@components/mixins/helper";
import WatchlistDisplayModal from "@/views/alert-hub/WatchlistDisplayModal";
import { redirectToRH } from "@utils/util";
import { snackbar } from "@components/mixins/snackbar";
import { recheckTask } from "@services/functional-api";

export default {
    mixins: [helper, snackbar],
    components: {
        WatchlistDisplayModal,
    },
    data() {
        return {
            selectedBook: undefined,
            tableHeader: [
                {
                    text: this.$t("common.table.rank"),
                    value: "rank",
                    width: 10,
                    align: "right",
                },
                {
                    text: this.$t("common.table.login"),
                    value: "login",
                    width: 30,
                },
                {
                    text: this.$t("common.table.server"),
                    value: "server",
                    width: 30,
                },
                {
                    text: this.$t("common.table.volumeStdLot"),
                    value: "volume_usd",
                    width: 30,
                    align: "right",
                },
                {
                    text: this.$t("common.table.dailyNetPnl"),
                    value: "pnl",
                    width: 30,
                    align: "right",
                },
                {
                    text: this.$t("common.table.unrealizedEod"),
                    value: "open_pnl",
                    width: 30,
                    align: "right",
                },
                {
                    text: this.$t("common.table.realizedEod"),
                    value: "close_pnl",
                    width: 30,
                    align: "right",
                },
                {
                    text: this.$t("common.table.action"),
                    value: "action",
                    width: 50,
                    align: "right",
                },
            ],
            tableData: [],
            loading: false,
            interval: null,
            watchlistModal: false,
            watchlistData: [],
            aiResult: {},
            showAiAnalysisButton: false,
            bookOptions: [],
        };
    },
    computed: {
        ...mapState("Home", ["books"]),
    },
    watch: {
        books(nv, ov) {
            if (JSON.stringify(nv) !== JSON.stringify(ov)) {
                const result = [];
                this.bookOptions = nv.flatMap((book) =>
                    book.children?.length
                        ? [
                              book.book_name,
                              ...book.children.map((c) => c.book_name),
                          ]
                        : [book.book_name]
                );
                this.updateBook();
            }
        },
        selectedBook(nv, ov) {
            if (nv !== ov) {
                this.fetchData();
            }
        },
        selectedMode(nv, ov) {
            if (nv !== ov) {
                this.fetchData();
            }
        },
    },
    methods: {
        ...mapActions("AlertHub", ["getRHUsersAction"]),
        ...mapMutations(["OPEN_MSG_DIALOG"]),
        fetchData() {
            if (this.interval) {
                clearInterval(this.interval);
            }

            this.apiCall();
            this.interval = setInterval(() => {
                this.apiCall();
            }, 1000 * 60);
        },
        apiCall() {
            this.loading = true;
            const params = {
                type: "volume_usd",
                book: this.selectedBook,
                mode: "top",
            };
            fetchRankingData(params)
                .then(({ data }) => {
                    this.tableData = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateBook() {
            if (this.bookOptions.includes("B")) {
                this.selectedBook = "B";
            } else {
                this.selectedBook = this.bookOptions?.[0];
            }
        },
        redirectTo(type, login, server, info) {
            let url = "";
            switch (type) {
                case "info":
                    url = `/tag-centre/account-analysis/${server}-${login}`;
                    redirectToRH(url);
                    break;
                case "add":
                    url = `/watch-list?mode=add&login=${login}&server=${server}`;
                    redirectToRH(url);
                    break;
                case "view":
                    this.watchlistData = info;
                    this.watchlistModal = true;
                    break;
                default:
                    break;
            }
        },
        getResult(item) {
            this.snackBarInfo(
                "Requesting AI analysis, it may take around 30 seconds to complete.",
                3000
            );
            const params = {
                type: "Intraday Risky Account",
                recheck_param: {
                    login: item.login,
                    server_id: item.server_id,
                    server_name: item.server,
                    book: this.selectedBook,
                },
                instant_response: true,
            };

            this.aiResult = {
                ...this.aiResult,
                [this.selectedBook + ":" + item.server_id + ":" + item.login]:
                    "loading",
            };

            let resultData = null;

            recheckTask(params)
                .then(({ data }) => {
                    resultData = data;
                })
                .finally(() => {
                    this.aiResult = {
                        ...this.aiResult,
                        [this.selectedBook +
                        ":" +
                        item.server_id +
                        ":" +
                        item.login]: resultData,
                    };
                });
        },
        openMessage(content) {
            this.$store.commit("OPEN_MSG_DIALOG", content);
        },
    },
    mounted() {
        const permission = JSON.parse(localStorage.getItem("permission"));
        this.showAiAnalysisButton =
            permission?.frontPermission?.book?.function?.includes(
                "showAiAnalysisButton"
            );

        this.getRHUsersAction();

        if (this.books?.length) {
            this.bookOptions = this.books.flatMap((book) =>
                book.children?.length
                    ? [book.book_name, ...book.children.map((c) => c.book_name)]
                    : [book.book_name]
            );
            this.updateBook();
        }
    },
    destroyed() {
        this.selectedBook = undefined;
        clearInterval(this.interval);
        this.interval = null;
    },
};
</script>

<style scoped>
.placeholder {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.filter-row {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    flex-shrink: 0;
}
.placeholder > div:last-child {
    flex: 1;
    min-height: 0;
}
.placeholder >>> .v-data-table {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.placeholder >>> .v-data-table__wrapper {
    flex: 1;
}
</style>
